import { graphql } from '@apollo/react-hoc';
import { compose } from 'react-recompose';
import { SimpleGraphQLComponent } from '../../utils/apollo';
import CollegeEventsEditEventComponent from './edit-event';

import fetchCollegeEventQuery from './graphql/fetchCollegeEventQuery';
import createCollegeEventMutation from './graphql/createCollegeEventMutation';
import updateCollegeEventMutation from './graphql/updateCollegeEventMutation';
import { withEnabledFeatures } from '../../utils/features';
import { withHEAccountSubscriptions } from '../../utils/subscriptions';

const createCollegeEvent = graphql(
  createCollegeEventMutation,
  {
    name: 'createCollegeEvent',
    options: {
      refetchQueries: ['fetchCollegeEvents'],
      awaitRefetchQueries: true,
    },
  },
);

const updateCollegeEvent = graphql(
  updateCollegeEventMutation,
  {
    name: 'updateCollegeEvent',
    options: {
      refetchQueries: ['fetchCollegeEvents'],
      awaitRefetchQueries: true,
    },
  },
);

const graphqlData = graphql(fetchCollegeEventQuery, {
  options: ({ params }) => {
    const { id } = params;
    return {
      variables: {
        id,
      },
    };
  },
});

export default SimpleGraphQLComponent(
  compose(
    withEnabledFeatures,
    withHEAccountSubscriptions,
    graphqlData,
  ),
  createCollegeEvent,
  updateCollegeEvent,
)(CollegeEventsEditEventComponent);
